export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured for your peace of mind. We meet all safety standards and regulations.'
    },
    {
      icon: 'ri-sparkling-fill',
      title: 'Clean & Sanitized Equipment',
      description: 'Every item is professionally cleaned and sanitized before and after each rental. Your safety is our priority.'
    },
    {
      icon: 'ri-time-fill',
      title: 'On-Time Delivery',
      description: 'Reliable delivery and setup when you need it. We respect your schedule and arrive on time, every time.'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Exceptional Customer Service',
      description: 'Friendly, professional staff dedicated to making your event perfect. We go above and beyond for every client.'
    },
    {
      icon: 'ri-price-tag-3-fill',
      title: 'Competitive Pricing',
      description: 'Fair, transparent pricing with no hidden fees. Get the best value for premium quality equipment and service.'
    },
    {
      icon: 'ri-map-pin-fill',
      title: 'Local Lehigh Valley Company',
      description: 'Proudly serving Allentown, Bethlehem, Easton and surrounding areas for over 15 years. We know the community.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            Why Choose Fun Affairs?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're the trusted choice for event entertainment rentals in the Lehigh Valley. Here's what sets us apart.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:border-red-200 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-500 rounded-xl mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}